import { Page, StyleSheet, Text, View } from "@react-pdf/renderer";
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#E4E4E4",
    padding: 8,
    rotate: 90,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  title: {
    fontSize: 24,
    marginBottom: 8,
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: { margin: "auto", flexDirection: "row" },
  tableCol: {
    width: "16.6%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center",
    padding: 8,
  },
});

export const ErrorPDF = () => {
  return (
    <Page size="A2" style={styles.page}>
      <View style={styles.section}>
        <Text style={styles.title}>Erro na leitura do PDF</Text>
      </View>
    </Page>
  );
};
